
<div>
    <app-bar :title="t('groups_title')"></app-bar>

    <v-layout>
        <group-collection></group-collection>
    </v-layout>
</div>
